import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const SignType = 2

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLoginRes() {
  return Cookies.get(SignType)
}

export function setLoginRes(tokenRes) {
  return Cookies.set(SignType, tokenRes)
}





// WEBPACK FOOTER //
// ./src/utils/auth.js